interface ClassicHeaderData {
  shareLinkText: string;
  shareLinkTextCopied: string;
  joyLogoAltText: string;
}

export const classicHeaderData: ClassicHeaderData = {
  shareLinkText: 'Share Link',
  shareLinkTextCopied: 'Copied!',
  joyLogoAltText: 'Joy Logo Transparent',
};
